export default __webpack_public_path__ + "static/media/badge-app-store.621b45d8.svg";